import type { Guide } from '../types';

/** S-21.10-18 — pięć pasm marży od kosztu (scenariusz e2e 21, ścieżka TRD-06 krok 1; e2e 12 przy ofertach). */
export const guide: Guide = {
  flagKey: 'marginFiveBands',
  title: 'Pięć pasm marży',
  whatItDoes:
    'Przy marży stoi jedno z pięciu pasm: strata krytyczna (poniżej −50%), strata (od −50% do 0%), marża minimalna (od 0% do 10%), marża normalna (od 10% do 70%) albo do weryfikacji (powyżej 70%). Procent liczymy od kosztu — w Trade od stawki przewoźnika z rejestru ofert, w rekomendacjach pojazdów i rekomendowanych zleceniach dla pojazdu od kosztu własnego, czyli dolotu i trasy według stawek spółki pojazdu. Pasmo to tylko oznaczenie: niczego nie blokuje i nie zmienia kolejności pojazdów ani ofert. Dotąd były cztery progi w procentach wartości zlecenia, puste do czasu podania liczb; granice pasm zmienia administrator w „Parametrach rekomendacji”, z powodem i historią.',
  audience: ['Trade', 'planista FTL', 'Team Leader (planista główny)', 'administrator'],
  presentationItems: ['S-21.10-18'],
  steps: [
    {
      route: '/user-offers/:orderId/show',
      record: {
        description: 'zlecenie w Trade z ofertą przewoźnika',
        listPath: '/user-offers',
        listFilter: { forklift: 'hide', dzial: 'TRADE', carrierOffers: true },
      },
      target: 'offer-margin-band-*',
      title: 'Pasmo przy ofercie przewoźnika',
      description:
        'W „Ofertach przewoźników” każda oferta ma marżę wobec ceny zlecenia i pasmo liczone od stawki przewoźnika (kosztu frachtu). W dymku pasma — granice i procent kosztu.',
      action: 'Otwórz zlecenie w Trade i najedź na pasmo przy ofercie.',
      recorder: { account: 'trade', demo: { kind: 'order', number: 'DEMO/2026/10/C01' } },
    },
    {
      route: '/user-offers/:orderId/show',
      record: {
        description: 'dowolne zlecenie w planowaniu FTL',
        listPath: '/user-offers',
        listFilter: { forklift: 'hide', dzial: 'FTL' },
      },
      target: 'margin-band',
      title: 'Pasmo w rekomendacjach pojazdów',
      description:
        'Przy każdym kandydacie pod kosztem dolotu stoi marża i jej pasmo — tu procent liczymy od kosztu własnego, czyli dolotu i trasy zlecenia. Kolejność pojazdów zostaje po dolocie; tak samo na karcie pojazdu w „Rekomendowanych zleceniach dla pojazdu”.',
      action: 'Na karcie zlecenia kliknij „Pokaż rekomendowane pojazdy” i najedź na pasmo przy marży.',
      recorder: {
        account: 'master',
        demo: { kind: 'order', number: 'DEMO/2026/09/001' },
        actions: [{ kind: 'clickButton', name: 'Pokaż rekomendowane pojazdy' }],
      },
    },
    {
      route: '/suggestion-parameters',
      target: 'margin-bands-note',
      title: 'Granice pasm w parametrach',
      description:
        'Sekcja „Pasma marży” w „Parametrach rekomendacji” ma cztery granice: −50, 0, 10 i 70% kosztu. To wartości robocze — zmiana wymaga powodu i trafia do historii parametrów.',
      action: 'Otwórz „Parametry rekomendacji” w menu „Administracja” i przy granicy kliknij „Zmień” albo „Historia”.',
      recorder: { account: 'admin' },
    },
  ],
};
